import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, CheckMarkIcon } from '@streamr/tv-ui';
import styled from 'styled-components';
import { CenteredContentContainer } from '../components/layout/content/CenteredContentContainer';
import { HeaderWithCenteredLogo } from '../components/layout/headers/HeaderWithCenteredLogo';
import { PageLayout } from '../components/layout/PageLayout';
export const MerchantOnboardingReturnPage = () => {
    return (_jsx(PageLayout, { header: _jsx(HeaderWithCenteredLogo, {}), children: _jsx(CenteredContentContainer, { children: _jsx("div", { children: _jsxs(GlassContainer, { className: "tv-ui-bright-glass-container tv-ui-shiny-border", children: [_jsx(IconContainer, { children: _jsx(CheckMarkIcon, { size: "x2" }) }), _jsx(ThankYouTitle, { children: "Thank you!" }), _jsx("p", { className: "tv-ui-font-medium", children: "Your Merchant account has been created successfully!" }), _jsxs("ul", { children: [_jsxs(ListElement, { children: [_jsx(EmojiContainer, { children: _jsx(Emoji, { children: "\u26A1" }) }), _jsx("span", { children: "Enable fast, secure Viewer contributions and payouts via Stripe." })] }), _jsxs(ListElement, { children: [_jsx(EmojiContainer, { children: _jsx(Emoji, { children: "\uD83D\uDCB8" }) }), _jsx("span", { children: "Keep 90%+ of all contributions." })] }), _jsxs(ListElement, { children: [_jsx(EmojiContainer, { children: _jsx(Emoji, { children: "\uD83E\uDD1D" }) }), _jsx("span", { children: "Earnings for All \u2013 Creators, teams & causes can earn from any broadcast." })] })] }), _jsx(StartBroadcastingButton, { tag: "a", href: "/", children: "Start Broadcasting" })] }) }) }) }));
};
const GlassContainer = styled.div `
    --BrightGlassContainer_BorderRadius: var(--tv-ui-border-radius-2);
    --tv-ui-shiny-border-radius: var(--tv-ui-border-radius-2);
    padding: 2rem;
    width: 100%;
    max-width: 40rem;
    display: flex;
    flex-direction: column;
    gap: 2rem;
    align-items: center;
    justify-content: center;
    margin: auto 0;
    box-sizing: border-box;
`;
const IconContainer = styled.div `
    display: flex;
    align-items: center;
    justify-content: center;
    width: 5rem;
    height: 5rem;
    background: var(--tv-ui-color-9);
    border-radius: 50%;

    svg {
        transform: scale(3);
    }
`;
const ThankYouTitle = styled.h1 `
    font-size: 2rem;
    font-weight: 600;
    text-align: center;
`;
const ListElement = styled.li `
    display: grid;
    grid-template-columns: 2.5rem 1fr;
    width: 100%;
    margin: 0 auto 1rem;
    align-items: center;
    gap: 1rem;

    @media (min-width: 40rem) {
        width: 70%;
    }

`;
const EmojiContainer = styled.div `
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 2.5rem;
    min-height: 2.5rem;
    border-radius: 50%;
    flex: 1;
    background-color: var(--tv-ui-glass-background);
`;
const Emoji = styled.span `
    font-size: 1.25rem;
`;
const StartBroadcastingButton = styled(Button) `
    --Button_Background: var(--tv-ui-color-3);
    --Button_TextColor: var(--tv-ui-color-4);
    --Button_TextSize: 1.125rem;
    --Button_HoverBackground: var(--tv-ui-color-3);
    --Button_BorderRadius: 1rem;
    --Button_Padding: 1rem 2rem;
    --Button_HoverTransform: scale(1.02);
    --Button_ActiveTransform: scale(1.02);
`;
